import React from 'react';
import { Link } from 'react-router-dom';
import { Gamepad2, Play, User } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const slugify = (t) =>
  (t || 'game').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '').slice(0, 60) || 'game';

export const ArcadeGameCard = ({ game, showCreator = true }) => {
  const playUrl = `/play/${slugify(game.title)}/${game.game_id}`;
  return (
    <div
      data-testid={`arcade-game-card-${game.game_id}`}
      className="group bg-gradient-to-br from-gray-900 to-gray-800 rounded-2xl border border-white/10 hover:border-purple-500/50 transition-all duration-300 overflow-hidden flex flex-col"
    >
      <Link to={playUrl} className="block relative aspect-video bg-black/60 overflow-hidden">
        {game.has_thumbnail ? (
          <img
            src={`${BACKEND_URL}/api/arcade/games/${game.game_id}/thumbnail.jpg`}
            alt={`${game.title} gameplay`}
            loading="lazy"
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
          />
        ) : (
          <div className="w-full h-full bg-gradient-to-br from-purple-900/40 via-gray-900 to-pink-900/30 flex items-center justify-center">
            <Gamepad2 size={44} className="text-purple-400/70" />
          </div>
        )}
        <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
          <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-purple-600 text-white text-sm font-semibold">
            <Play size={16} /> Play Now
          </span>
        </div>
      </Link>
      <div className="p-4 flex flex-col gap-1 flex-1">
        <Link to={playUrl} className="text-white font-semibold truncate hover:text-purple-300 transition-colors">
          {game.title}
        </Link>
        <div className="flex items-center justify-between text-xs text-gray-400 mt-auto pt-2">
          {showCreator && game.creator_username ? (
            <Link
              to={`/creator/${encodeURIComponent(game.creator_username)}`}
              data-testid={`arcade-creator-link-${game.game_id}`}
              className="inline-flex items-center gap-1 hover:text-purple-300 transition-colors"
            >
              <User size={12} /> {game.creator_username}
            </Link>
          ) : (
            <span />
          )}
          <span>{(game.plays || 0).toLocaleString()} plays</span>
        </div>
      </div>
    </div>
  );
};

export default ArcadeGameCard;
